export var theme = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        rowGap: '30px',
        width: '100%',
        margin: '0 auto 2rem',
    },
    list: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: 2,
        padding: '0 16px',
    },
    listItem: {
        display: 'flex',
        justifyContent: 'space-between',
        columnGap: 4,
    },
    description: {
        flex: '0 0 60%',
    },
    validationError: {
        position: 'absolute',
    },
};
